<template>
    <div>

    <section class="contact d-flex align-items-center">
        <div class="container py-5">
            
        </div>
    </section>

    <section class="py-4">
        <div class="container">
            <div class="p-4">                
                <h5 class="fw-bold mb-2"><span style="color:var(--brand)">CONTACT US</span></h5>                
                <div class="d-flex justify-content-start" style="padding-top: 20px;">
                    <div><MapPin class="me-2 text-info" /></div>
                    <div>
                        <p class="mb-0">
                            Unit 130, 201 38 Ave NE
                            Calgary Alberta, Canada T2E 2M3
                        </p>
                    </div>
                </div>                                                
               <div class="map-container d-flex justify-content-center" style="padding-top: 16px;" >
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1156.3032634868232!2d-114.0328239798662!3d51.05020997956371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716f3f7e6f4d7b%3A0x5c4e8f4e8e8e8e8e!2sUnit%20130%2C%20201%2038%20Ave%20NE%2C%20Calgary%2C%20AB%20T2E%202M3%2C%20Canada!5e0!3m2!1sen!2sus!4v1701301234567!5m2!1sen!2sus" 
                        width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    
                </div>
            </div>

             <div class="p-4">
                <div class="d-flex justify-content-start">
                    <div><Mail class="me-2 text-info" /></div>
                    <div><a class="link-light text-decoration-none" href="mailto:office@RichviewEng.com?subject=Inquiry&body=Hello, I would like to know more about your services.">
                        office@RichviewEng.com</a></div>
                </div>
                <div class="d-flex justify-content-start" style="padding-top: 24px;">
                    <div><Phone class="me-2 text-info" /></div>
                    <div><p class="mb-0">(403)230-3218</p></div>
                </div>                
             </div>
        </div>
    </section>

    </div>
</template>


<script setup>


import { MapPin,Mail,Phone } from 'lucide-vue-next'

</script>


<style scoped>

</style>